import CommonImage from '@/components/CommonImage';
import { getCostingAssesmentTagColor } from '@/features/Scan/utils';

const StyleImage = ({ style }) => (
	<div className="card-top">
		<CommonImage src={style?.designDocuments?.[0]?.docUrl} isStatic={false} />
	</div>
);

const StyleDetails = ({ style, setIsShowTags, onClickAddTag }) => {
	const renderProductTags = (design) => {
		return design?.tagResponseList?.map((item, index) => (
			<span key={`tag_${index}`} style={{ background: item.colorCode }} className="status radius">
				{item.text}
			</span>
		));
	};
	return (
		<div className="card-content ml-12">
			{style?.isNotFound && <span className="status brown-2">Not found</span>}
			<p class="regular-12 weight-500 gray_dark_01 my-1">{style.referenceNumber}</p>
			{style?.sampleInventoryItemResponseList?.length > 0 && (
				<p className="regular-12 gray_dark_02 mt-1">
					{
						style?.sampleInventoryItemResponseList[0]?.sampleInventoryLocationResponse
							?.countryResponse?.code
					}
					:
					<span className="gray_dark_01">
						{' '}
						{style?.sampleInventoryItemResponseList?.[0]?.sampleId}{' '}
					</span>
				</p>
			)}

			<ul class="common-list-component mt-1">
				{style.basePrice && (
					<li className="d-flex align-items-center">
						{style.basePrice && (
							<span class="mb-0 semibold-12">P:${style.basePrice.toFixed(2)}</span>
						)}
					</li>
				)}
				<li>
					{style?.costingReviewAssessmentResponse?.constant && (
						<span
							className={`status red-1 my-1 status-with-border ${getCostingAssesmentTagColor(style?.costingReviewAssessmentResponse?.constant)}`}
						>
							{style?.costingReviewAssessmentResponse?.name}
						</span>
					)}
				</li>
				{style?.tagResponseList?.length > 0 && (
					<li>
						<div className="tags design-tags mt-1">{renderProductTags(style)}</div>
					</li>
				)}

				<li
					className="underline mt-2 mb-1"
					onClick={(e) => {
						e.stopPropagation();
						setIsShowTags(true);
						onClickAddTag(style);
					}}
				>
					Tag & Comment
				</li>
			</ul>
		</div>
	);
};

const StyleRow = ({
	style,
	onRemoveItem,
	onOpenDesignView,
	index,
	isShowTags,
	setIsShowTags,
	onClickAddTag
}) => (
	<tr>
		<td>{index}</td>
		<td className="scan-list-item-column" onClick={() => onOpenDesignView(style)}>
			{!style.isFound && (
				<div className="card-content ml-12">
					<span className="status brown-2">Style Not found</span>
					<p class="regular-12 weight-500 gray_dark_01 my-1">{style?.designNumber}</p>
					<p className="regular-12 gray_dark_02 mt-1">
						Sample ID:<span className="gray_dark_01"> {style?.sampleId} </span>
					</p>
				</div>
			)}
			{style.isFound && (
				<div className="single-design-card d-flex align-items-center">
					<StyleImage style={style} />
					<StyleDetails
						style={style}
						isShowTags={isShowTags}
						setIsShowTags={setIsShowTags}
						onClickAddTag={onClickAddTag}
					/>
				</div>
			)}
		</td>
		<td className="action-column">
			<CommonImage
				src="/icons/trash.svg"
				className="cursor-pointer"
				width={20}
				height={20}
				onClick={() => onRemoveItem(style?.sampleInventoryItemResponseList?.[0]?.id, style?.id)}
			/>
		</td>
	</tr>
);

const ScannedStylesListView = ({
	styles,
	onRemoveItem,
	removeAll,
	onOpenDesignView,
	isShowTags,
	setIsShowTags,
	onClickAddTag
}) => {
	return (
		<table className="table w-100 no-hover with-border">
			<thead></thead>
			<tbody>
				<tr>
					<th className="regular-14 align-middle">SL</th>
					<th className="regular-14 align-middle">Scanned output</th>
					<th className="text-center action-column align-middle">
						{styles.length > 0 && (
							<CommonImage
								src="/icons/trash.svg"
								className="cursor-pointer"
								onClick={() => removeAll()}
							/>
						)}
					</th>
				</tr>
				{styles.map((style, index) => (
					<StyleRow
						key={`${style.id}_${index}`}
						style={style}
						onRemoveItem={onRemoveItem}
						onOpenDesignView={onOpenDesignView}
						index={index + 1}
						isShowTags={isShowTags}
						setIsShowTags={setIsShowTags}
						onClickAddTag={onClickAddTag}
					/>
				))}
			</tbody>
		</table>
	);
};

export default ScannedStylesListView;
